import React from "react";
import HomePageNewsSkeleton from "../News/HomePageNewsSkeleton";

const NewsSectionSkeleton: React.FC = () => {
  return (
    <div>
      <section className="grid grid-cols-2 max-lg:grid-cols-1 max-md:overflow-hidden max-md:px-4">
        <div className="flex items-end flex-col gap-4 max-md:py-6 py-12 max-lg:text-start max-sm:text-center max-lg:px-4">
          <span className="block bg-gray-300 skeleton w-[200px] h-10 rounded"></span>
          <span className="block bg-gray-300 skeleton w-[320px] h-10 rounded"></span>
          <h2 className="text-7xl text-[#89D9EE] mt-4 f-family-monoton max-md:text-3xl block w-[246px] h-[72px] bg-gray-300 rounded"></h2>
        </div>
        <HomePageNewsSkeleton />
      </section>
    </div>
  );
};

export default NewsSectionSkeleton;
